import { AuthClient } from "../data/auth-client";

async function GenerateUserProfile() {
  try {
    const authClient = new AuthClient();

    const response = await authClient.getUserProfile();

    return response;
  } catch (err) {
    console.error("Generate User Profile error", err);
    throw new Error("Hubo un problema al generar el perfil del usuario.");
  }
}

export default GenerateUserProfile;
